import { IAttribute } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { SqlTypeCopySource } from './sql-type.copysource';
import { AzureSqlDWTableDataset } from 'app/model/dataset/azure-sql-dw-table.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

import { IsolationLevelType } from 'app/registries/consts/sql-const';
import { partitionOptionConst } from 'app/registries/consts/metadata-consts';

@Metamodel.model({
    name: adfModelTypeMap.azureSqlDW.copySourceType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(AzureSqlDWTableDataset) }
})
export class SqlDWCopySource extends SqlTypeCopySource {
    public static readonly QUERY_TIMEOUT: IAttribute;
    public static readonly ISOLATION_LEVEL: IAttribute;
    public static readonly PARTITION_OPTION: IAttribute;
    public static readonly PARTITION_COLUMN_NAME: IAttribute;
    public static readonly PARTITION_UPPER_BOUND: IAttribute;
    public static readonly PARTITION_LOWER_BOUND: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'QUERY_TIMEOUT',
        display: stringResources.ModelName_Source_QueryTimeout_Min,
        accepts: ['String'],
        constraint: {
            minimum: 1,
            maximum: 1440
        }
    })
    public queryTimeout?: number = 120;

    @Metamodel.attribute({
        templatable: true,
        association: 'ISOLATION_LEVEL',
        display: stringResources.DataFlowSQLIsolationLevel
    })
    public isolationLevel?: IsolationLevelType;

    @Metamodel.attribute({
        templatable: true,

        association: 'PARTITION_OPTION',
        display: stringResources.ModelName_Partition_Option
    })
    public partitionOption?: string = partitionOptionConst.none;

    @Metamodel.attribute({
        templatable: true,
        association: 'PARTITION_COLUMN_NAME',
        display: stringResources.ModelName_Partition_ColumnName
    })
    public partitionColumnName?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'PARTITION_UPPER_BOUND',
        display: stringResources.ModelName_Partition_UpperBound
    })
    public partitionUpperBound?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'PARTITION_LOWER_BOUND',
        display: stringResources.ModelName_Partition_LowerBound
    })
    public partitionLowerBound?: string;
}
